<aside id="default-sidebar" class="sidenav" [class.is-collapsed]="collapsed" aria-label="Sidenav">
  <div class="sidenav-inner">
    <div class="sidenav-header">
      <div class="brand-text">
        <div class="brand-title">Portal</div>
        <div class="brand-subtitle">Administrador</div>
      </div>
      <button
        *ngIf="!collapsed"
        type="button"
        class="sidenav-close"
        (click)="closeSidenav()"
        aria-label="Cerrar menu"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 6l12 12"></path>
          <path d="M18 6L6 18"></path>
        </svg>
      </button>
    </div>

    <div class="sidenav-section-title">Men&uacute;</div>
    <ul class="sidenav-links">


      <li class="nav-group" [class.is-open]="isSectionOpen('solicitudes')">
        <button
          type="button"
          class="nav-link nav-parent"
          (click)="toggleSection('solicitudes')"
          [attr.aria-expanded]="isSectionOpen('solicitudes')"
          aria-controls="solicitudes-menu"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M5 5.5h5l2 2h7a2 2 0 0 1 2 2v7A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5V8a2.5 2.5 0 0 1 2-2.5Z" />
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
                d="M8 12h8M8 15.5h5" />
            </svg>
          </span>
          <span class="nav-label">Solicitudes</span>
          <span class="nav-chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>

        <div id="solicitudes-menu" class="nav-submenu" [class.is-open]="isSectionOpen('solicitudes')">
          <ul class="nav-submenu-list">
            <li>
              <a routerLink="/solicitud-listado" (click)="closeMobileSidenav()"
                routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link nav-sublink">
                <span class="nav-label">Solicitudes abiertas</span>
                <span *ngIf="pendientesCount > 0" class="nav-badge">{{ pendientesCount }}</span>
              </a>
            </li>
            <li>
              <a routerLink="/solicitud-listado" [queryParams]="{ vista: 'historial' }" (click)="closeMobileSidenav()"
                routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link nav-sublink">
                <span class="nav-label">Solicitudes cerradas</span>
              </a>
            </li>
            <li>
              <a routerLink="/solicitud-nueva" (click)="closeMobileSidenav()" routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }" class="nav-link nav-sublink">
                <span class="nav-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6" />
                    <path d="M12 8v8M8 12h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                  </svg>
                </span>
                <span class="nav-label">Nueva solicitud</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-group" [class.is-open]="isSectionOpen('presupuestos')">
        <button
          type="button"
          class="nav-link nav-parent"
          (click)="toggleSection('presupuestos')"
          [attr.aria-expanded]="isSectionOpen('presupuestos')"
          aria-controls="presupuestos-menu"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M7 3.8h10a2 2 0 0 1 2 2v14l-2-1.2-2 1.2-2-1.2-2 1.2-2-1.2-2 1.2v-14a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <path d="M10 8h4M10 12h6M10 16h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </span>
          <span class="nav-label">Presupuestos</span>
          <span class="nav-chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>

        <div id="presupuestos-menu" class="nav-submenu" [class.is-open]="isSectionOpen('presupuestos')">
          <ul class="nav-submenu-list">
            <li>
              <a routerLink="/presupuesto-listado" (click)="closeMobileSidenav()" routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }" class="nav-link nav-sublink">
                <span class="nav-label">Presupuestos abiertos</span>
                <span *ngIf="presupuestosPendientesCount > 0" class="nav-badge">{{ presupuestosPendientesCount }}</span>
              </a>
            </li>
            <li>
              <a routerLink="/presupuesto-listado" [queryParams]="{ vista: 'historial' }" (click)="closeMobileSidenav()" routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }" class="nav-link nav-sublink">
                <span class="nav-label">Presupuestos cerrados</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li>
        <a routerLink="/chat" (click)="closeMobileSidenav()" routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4.5 5.5h15v10.2a2 2 0 0 1-2 2H9l-4.5 3v-15.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <path d="M8 10h8M8 13.5h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </span>
          <span class="nav-label">Chat</span>
          <span *ngIf="chatUnreadCount > 0" class="nav-badge">{{ chatUnreadCount }}</span>
        </a>
      </li>

      <li>
        <a
          routerLink="/panel-control/actividad"
          (click)="closeMobileSidenav()"
          [class.is-active]="isRouteActive('/panel-control')"
          class="nav-link"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 13.5h6.5V20H4v-6.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <path d="M13.5 4H20v16h-6.5V4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <path d="M4 4h6.5v6.5H4V4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
            </svg>
          </span>
          <span class="nav-label">Panel de control</span>
        </a>
      </li>

    </ul>

    <div class="sidenav-footer">
      <div class="sidenav-footer-divider" aria-hidden="true"></div>
      <button type="button" (click)="logout()" class="nav-link logout-link">
        <span class="nav-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M4.5 6.5A2.5 2.5 0 0 1 7 4h5a2.5 2.5 0 0 1 2.5 2.5V8" />
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M14.5 16v1.5A2.5 2.5 0 0 1 12 20H7a2.5 2.5 0 0 1-2.5-2.5v-11" />
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M11 12h9m0 0-3-3m3 3-3 3" />
          </svg>
        </span>
        <span class="nav-label">Cerrar sesi&oacute;n</span>
      </button>
    </div>
  </div>
</aside>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
